import React, { useEffect } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'
import { usePreviewProvider } from 'modules/processes/components/ItemWizard/Providers/preview'
import { ToogleCard } from 'modules/processes/components/ItemWizard/components/Form/Items/ToogleCard'
import { DataCollectionCategories } from 'modules/processes/domain'

const UploadId = () => {
  const { setPreviewValues, previewValues } = usePreviewProvider()
  const { associatedTaskItem: item, form } = useFormProvider()

  const uploadBankCertificate = form.get('data_collection_configuration').value
    .uploadBankCertificate

  useEffect(() => {
    const taskConfiguration = item?.taskTypeConfiguration
      ? JSON.parse(item?.taskTypeConfiguration)
      : {}
    const category = taskConfiguration.configuration_fields?.at(0)?.categories?.at(0)
    const isUploadBankCertificateCollector =
      category?.category === DataCollectionCategories.bankInformation

    const enabled = isUploadBankCertificateCollector ? !!category.configuration?.folder_id : true

    form.setValues({
      data_collection_configuration: {
        uploadBankCertificate: previewValues.bankDetail
          ? previewValues.bankDetail?.uploadBankCertificate
          : enabled,
      },
    })
    setPreviewValues({
      bankDetail: {
        uploadBankCertificate: enabled,
      },
    })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box gap="s16">
      <ToogleCard
        title={i18n.t(
          'processes.process_settings.wizard.tasks.types.request_bank_account.form.upload_certificate.title'
        )}
        tooltip={i18n.t(
          'processes.process_settings.wizard.tasks.types.request_bank_account.form.upload_certificate.tooltip'
        )}
        tooglerValue={uploadBankCertificate}
        onChange={() => {
          form.setValues({
            data_collection_configuration: {
              uploadBankCertificate: !uploadBankCertificate,
            },
          })
          setPreviewValues({
            bankDetail: {
              uploadBankCertificate: !uploadBankCertificate,
            },
          })
        }}
      />
    </Box>
  )
}

export default UploadId
